export enum QUERY_KEYS {
  TEMPLATE_ATTRIBUTES = 'TEMPLATE_ATTRIBUTES',
  TEMPLATE_ATTRIBUTE = 'TEMPLATE_ATTRIBUTE',
}

export default QUERY_KEYS
